import { render, staticRenderFns } from "./UserLocked.vue?vue&type=template&id=20264a5d&lang=pug&"
import script from "./UserLocked.vue?vue&type=script&lang=js&"
export * from "./UserLocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserLocked.vue"
export default component.exports